import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { configureHost } from 'src/app/helpers/utils/links.helper';
import CustomURIEncoder from 'src/app/helpers/utils/CustomURIEncoder';

import { SettingsResponse } from 'src/app/shared/models/settingsResponse.model';
import RoomSearchParameters from 'src/app/shared/models/roomSearchParams.model';

import { LocalizationService } from 'src/app/services/localization/localization.service';

import { environment } from 'src/environments/environment';
import { Brands } from 'src/app/shared/constants/brands.constants';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  settings: SettingsResponse;

  constructor(
    private http: HttpClient,
    private localizationService: LocalizationService
  ) {}

  public getSettings(queryParams: Partial<RoomSearchParameters>): Observable<SettingsResponse> {
    const params = new HttpParams({ encoder: new CustomURIEncoder() })
      .set('locale', queryParams.locale)
      .set('countryName', queryParams.countryName)
      .set('countryCode', queryParams.countryCode);

    return this.http.get(`${environment.apiUrl}settings/domain-data`, { params }).pipe(
      tap((response: SettingsResponse) => {
        response.brand = response.brand?.toLowerCase() as Brands || Brands.REGUS;
        this.settings = response;
      })
    );
  }

  public getTermsConditionsUrl(): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}bookings/terms-conditions`);
  }

  public formLink(link: string): string {
    const hostName = configureHost(this.settings.brand);
    const lang = this.localizationService.lang.value;
    const BASE_URL = `${location.protocol}//${hostName}/${lang}`;

    return `${BASE_URL}/${link}`;
  }
}
